module.exports = __webpack_public_path__ + "img/IT0003084910677.5bf1220b.png";